// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewPanelsContainer_root__2ye5J"};